import {Box, Link, Tooltip} from "@mui/material";
import FacebookIcon from "../../images/facebook_icon.png"
import YouTubeIcon from "../../images/youtube_icon.png"
import SpotifyIcon from "../../images/spotify_icon.png"
import ApplePodcastsIcon from "../../images/apple_podcasts_icon.png"
import AmazonIcon from "../../images/amazon_icon.png"

const SocialLinks = () => {
  return (
    <Box display="flex" alignItems="center" height={20}>
      <Tooltip title="RBC YouTube Channel">
        <Link href="https://www.youtube.com/@RetirementBudgetCalculator" target="_blank" sx={{mr:1}}>
          <img src={YouTubeIcon} alt="YouTube Channel" height={20} width={20}/>
        </Link>
      </Tooltip>
      <Tooltip title="Facebook Page">
        <Link href="https://www.facebook.com/SoundRetirementPlanning" target="_blank" sx={{mr:1}}>
          <img src={FacebookIcon} alt="Facebook Page" height={20} width={20}/>
        </Link>
      </Tooltip>
      <Tooltip title="Spotify Podcast">
        <Link href="https://open.spotify.com/show/1Kghg0TvcinO8nGNSzE1WF?si=788a76f29a764bdc" target="_blank" sx={{mr:1}}>
          <img src={SpotifyIcon} alt="Spotify Podcast" height={20} width={20}/>
        </Link>
      </Tooltip>
      <Tooltip title="Apple Podcast">
        <Link href="https://podcasts.apple.com/us/podcast/sound-retirement-radio/id306719560" target="_blank" sx={{mr:1}}>
          <img src={ApplePodcastsIcon} alt="Apple Podcast" height={20} width={20}/>
        </Link>
      </Tooltip>
      <Tooltip title="Amazon Store">
        <Link href="https://www.amazon.com/stores/Jason-R-Parker/author/B00JGXAZAW" target="_blank" sx={{mr:1}}>
          <img src={AmazonIcon} alt="Aamazon Stire" height={20} width={20}/>
        </Link>
      </Tooltip>
    </Box>
  )
}

export default SocialLinks